export default __webpack_public_path__ + "static/media/guy--desktop.7aa1d169.jpg";